module.exports = {"id":"207653","name":"Miler Bolaños","rating":"73","photo":"./data/images/photos/3/207653.png","club":{"name":"Tijuana","logo":"./data/images/clubs/Tijuana.png"},"positions":["MOC","AD","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MilerBolanos0.json
// module id = 3038
// module chunks = 0